var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"v-icon",attrs:{"height":_vm.height,"width":_vm.width,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"href":require("./../../assets/circle.svg") + "#circle"}})])}
var staticRenderFns = []

export { render, staticRenderFns }